<template>
  <div class="w100 pt20 pb20 pl20 pr20 bg-w card-shadow" v-loading="loading">
    <p class="w100 bold mb20 font-18 tx-c">大厅访问趋势</p>
    <div class="w100 mt20 flex-box al-c">
      <DateComp class="mr10" ref="date" @change="fetchChartData" />
      <el-button type="primary" size="mini" @click="fetchChartData">查询</el-button>
    </div>

    <div class="w100 mt20">
      <ve-line :extend="option"></ve-line>
    </div>
  </div>
</template>

<script>
import DateComp from "@/components/public/DateComp";

export default {
  name: "AllView02",
  components: {
    DateComp
  },
  props: [],
  data() {
    return {
      loading: false,
      option: {
        color: ["#41b854", "#44b9fe", "#d9d93c"],
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: []
        },
        grid: {
          show: true,
          left: "3%",
          right: "4%",
          bottom: "5%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          name: "时间",
          type: "category",
          boundaryGap: false,
          data: []
        },
        yAxis: {
          name: "值",
          type: "value"
        },
        series: []
      }
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.fetchChartData();
  },
  destroyed() {},
  methods: {
    fetchChartData() {
      const date = this.$refs.date.getValue();
      this.loading = true;
      setTimeout(() => {
        const chart = {
          xData: [
            "6-30",
            "7-1",
            "7-2",
            "7-3",
            "7-4",
            "7-5",
            "7-6",
            "7-7",
            "7-8",
            "7-9",
            "7-10",
            "7-11",
            "7-12",
            "7-13",
            "7-14",
            "7-15",
            "7-16",
            "7-17",
            "7-18",
            "7-19",
            "7-20",
            "7-21",
            "7-22",
            "7-23",
            "7-24",
            "7-25",
            "7-26",
            "7-27",
            "7-28",
            "7-29",
            "7-30"
          ],
          yData: [
            {
              name: "浏览量（PV）",
              type: "line",
              data: [
                543,
                1579,
                2069,
                1059,
                781,
                693,
                213,
                198,
                611,
                665,
                917,
                565,
                554,
                330,
                424,
                404,
                425,
                570,
                1026,
                951,
                508,
                485,
                589,
                664,
                641,
                1079,
                1065,
                410,
                418,
                791,
                237
              ]
            },
            {
              name: "访客数（UV）",
              type: "line",
              data: [
                125,
                294,
                402,
                208,
                147,
                138,
                46,
                55,
                142,
                171,
                168,
                128,
                127,
                87,
                106,
                95,
                118,
                138,
                290,
                251,
                131,
                121,
                132,
                136,
                126,
                172,
                171,
                94,
                112,
                170,
                40
              ]
            },
            {
              name: "平均访问页数",
              type: "line",
              data: [
                4,
                5,
                5,
                5,
                5,
                5,
                4,
                3,
                4,
                3,
                5,
                4,
                4,
                3,
                4,
                4,
                3,
                4,
                3,
                3,
                3,
                4,
                4,
                4,
                5,
                6,
                6,
                4,
                3,
                4,
                5
              ]
            }
          ]
        };
        this.option.legend.data = chart.yData.map(val => val.name);
        this.option.xAxis.data = chart.xData;
        this.option.series = chart.yData;

        this.loading = false;
      }, 500);
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
</style>
